import { cx } from './cx';
import styles from './Card.module.css';

/**
 * Fläche für zusammengehörige Inhalte.
 * Mit onClick wird die Karte zur Schaltfläche (Tastatur und Screenreader inklusive).
 */
export function Card({ as: Tag = 'div', padding = 'md', onClick, className, children, ...props }) {
  const interactive = typeof onClick === 'function';
  return (
    <Tag
      className={cx(styles.card, styles[`pad-${padding}`], interactive && styles.interactive, className)}
      onClick={onClick}
      {...(interactive && Tag !== 'button' ? {
        role: 'button',
        tabIndex: 0,
        onKeyDown: (e) => {
          if (e.target !== e.currentTarget) return;
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick(e); }
        }
      } : {})}
      {...props}
    >
      {children}
    </Tag>
  );
}

/** Kleines Etikett für Status und Kategorien */
export function Badge({ tone = 'neutral', className, children }) {
  return <span className={cx(styles.badge, styles[`tone-${tone}`], className)}>{children}</span>;
}
